export default __webpack_public_path__ + "static/media/smiley-08.b9460795.png";